import React from 'react'
import CompleteLeads from './CompleteLeads';
import IncompleteLead from './Incomplete';
import RepeatLead from './repeatleads';
import Legal from './legal';
import RepeatComplete from "./RepeatComplete";
import { ABHICASH_ONLY, CHECK_COMPANY_TENANT,CASHBRIDGE_LIKE, CREDFIN_LIKE,CREDITJAR_LIKE } from '../../../../../layouts/MainTenantconfig';

class MainTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewTab: 'Complete',
            userStatusData: '',
            loaderState: false
        }
    }
    buttonHandle(data) {
        this.setState({ viewTab: data })
    }
    // getAssignedByStatus() {
    //     this.setState({ loaderState: true })
    //     fetch(APIS.GET_ASSIGN_BY_STATUS)
    //         .then(res => res.json())
    //         .then(res => {
    //             this.setState({
    //                 userStatusData: res,
    //                 loaderState: false
    //             })

    //         })
    // }
    // componentDidMount() {
    //     this.getAssignedByStatus()
    // }
    render() {
        const { admin } = this.props
        return (
            <div className='conatainer-fluid details-new'>

                <div className="btn-group btn-grp-own" role="group" aria-label="onboard-btn" style={{ marginTop: '10px', padding: '10px' }}>
                    <button className={`btn btn-outline-primary ${this.state.viewTab == "Complete" ? "active" : ""}`} style={{ background: '#F1F7FF', color: '#000' }} onClick={() => this.buttonHandle('Complete')}> Complete </button>
                    <button className={`btn btn-outline-primary ${this.state.viewTab == "Incomplete" ? "active" : ""}`} style={{ background: '#F1F7FF', color: '#000' }} onClick={() => this.buttonHandle('Incomplete')} > Incomplete </button>
                    <button className={`btn btn-outline-primary ${this.state.viewTab == "Repeat" ? "active" : ""}`} style={{ background: '#F1F7FF', color: '#000' }} onClick={() => this.buttonHandle('Repeat')} > Repeat </button>
                    <button className={`btn btn-outline-primary ${this.state.viewTab == "Operations" ? "active" : ""}`} style={{ background: '#F1F7FF', color: '#000' }} onClick={() => this.buttonHandle('Operations')} > Operations </button>
                    {
                        CHECK_COMPANY_TENANT(ABHICASH_ONLY) || CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDFIN_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                        <button
                        className={`btn btn-outline-primary ${this.state.viewTab == "repeatComplete" ? "active" : ""}`}
                        style={{ background: "#F1F7FF", color: "#000" }}
                        onClick={() => this.buttonHandle("repeatComplete")}
                        >
                        {" "}
                        Repeat Complete{" "}
                    </button>
                    :""}

                </div>
                {this.state.viewTab === 'Complete' ?
                    <CompleteLeads admin={admin} userStatusData={this.state.userStatusData} />
                    : ""}
                {this.state.viewTab === 'Incomplete' ?
                    <IncompleteLead admin={admin} userStatusData={this.state.userStatusData} />
                    : ""}
                {this.state.viewTab === 'Repeat' ?
                    <RepeatLead admin={admin} userStatusData={this.state.userStatusData} />
                    : ""}
                {this.state.viewTab === 'Operations' ?
                    <Legal admin={admin} userStatusData={this.state.userStatusData} />
                    : ""}
                {this.state.viewTab === "repeatComplete" ? (
                    <RepeatComplete
                        admin={admin}
                        userStatusData={this.state.userStatusData}
                    />
                ) : (
                    ""
                )}
            </div>
        )
    }
}
export default MainTab